/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiScreeningHitClearanceState } from './ApiScreeningHitClearanceState';
import {
    ApiScreeningHitClearanceStateFromJSON,
    ApiScreeningHitClearanceStateFromJSONTyped,
    ApiScreeningHitClearanceStateToJSON,
    ApiScreeningHitClearanceStateToJSONTyped,
} from './ApiScreeningHitClearanceState';
import type { ApiSanctionFilter } from './ApiSanctionFilter';
import {
    ApiSanctionFilterFromJSON,
    ApiSanctionFilterFromJSONTyped,
    ApiSanctionFilterToJSON,
    ApiSanctionFilterToJSONTyped,
} from './ApiSanctionFilter';
import type { ApiScreeningHitAiInsight } from './ApiScreeningHitAiInsight';
import {
    ApiScreeningHitAiInsightFromJSON,
    ApiScreeningHitAiInsightFromJSONTyped,
    ApiScreeningHitAiInsightToJSON,
    ApiScreeningHitAiInsightToJSONTyped,
} from './ApiScreeningHitAiInsight';
import type { ApiScreeningGoodlistReference } from './ApiScreeningGoodlistReference';
import {
    ApiScreeningGoodlistReferenceFromJSON,
    ApiScreeningGoodlistReferenceFromJSONTyped,
    ApiScreeningGoodlistReferenceToJSON,
    ApiScreeningGoodlistReferenceToJSONTyped,
} from './ApiScreeningGoodlistReference';
import type { ApiSanctionRecord } from './ApiSanctionRecord';
import {
    ApiSanctionRecordFromJSON,
    ApiSanctionRecordFromJSONTyped,
    ApiSanctionRecordToJSON,
    ApiSanctionRecordToJSONTyped,
} from './ApiSanctionRecord';
import type { ApiScreeningMatchProvider } from './ApiScreeningMatchProvider';
import {
    ApiScreeningMatchProviderFromJSON,
    ApiScreeningMatchProviderFromJSONTyped,
    ApiScreeningMatchProviderToJSON,
    ApiScreeningMatchProviderToJSONTyped,
} from './ApiScreeningMatchProvider';

/**
 * 
 * @export
 * @interface ApiSanctionHit
 */
export interface ApiSanctionHit {
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionHit
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionHit
     */
    sanctionAlertId: number;
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionHit
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionHit
     */
    inputData: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionHit
     */
    matchData: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionHit
     */
    sanctionList: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiSanctionHit
     */
    createdTime: Date;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionHit
     */
    highlight?: string;
    /**
     * 
     * @type {Array<ApiSanctionFilter>}
     * @memberof ApiSanctionHit
     */
    filters: Array<ApiSanctionFilter>;
    /**
     * 
     * @type {ApiScreeningGoodlistReference}
     * @memberof ApiSanctionHit
     */
    goodlistReference?: ApiScreeningGoodlistReference;
    /**
     * 
     * @type {Array<ApiScreeningHitClearanceState>}
     * @memberof ApiSanctionHit
     */
    clearances: Array<ApiScreeningHitClearanceState>;
    /**
     * 
     * @type {ApiSanctionHitScreeningSubtypeEnum}
     * @memberof ApiSanctionHit
     */
    screeningSubtype?: ApiSanctionHitScreeningSubtypeEnum;
    /**
     * 
     * @type {ApiSanctionRecord}
     * @memberof ApiSanctionHit
     */
    record?: ApiSanctionRecord;
    /**
     * 
     * @type {ApiScreeningMatchProvider}
     * @memberof ApiSanctionHit
     */
    matchProvider?: ApiScreeningMatchProvider;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionHit
     */
    screenablePath?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionHit
     */
    matchSourceId?: number;
    /**
     * 
     * @type {ApiScreeningHitAiInsight}
     * @memberof ApiSanctionHit
     */
    aiInsight?: ApiScreeningHitAiInsight;
}

/**
* @export
* @enum {string}
*/
export enum ApiSanctionHitScreeningSubtypeEnum {
    BIC = 'BIC',
    BANK_NAME = 'BANK_NAME',
    NAME = 'NAME',
    REFERENCE = 'REFERENCE'
}


/**
 * Check if a given object implements the ApiSanctionHit interface.
 */
export function instanceOfApiSanctionHit(value: object): value is ApiSanctionHit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sanctionAlertId' in value) || value['sanctionAlertId'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('inputData' in value) || value['inputData'] === undefined) return false;
    if (!('matchData' in value) || value['matchData'] === undefined) return false;
    if (!('sanctionList' in value) || value['sanctionList'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('clearances' in value) || value['clearances'] === undefined) return false;
    return true;
}

export function ApiSanctionHitFromJSON(json: any): ApiSanctionHit {
    return ApiSanctionHitFromJSONTyped(json, false);
}

export function ApiSanctionHitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionHit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sanctionAlertId': json['sanctionAlertId'],
        'score': json['score'],
        'inputData': json['inputData'],
        'matchData': json['matchData'],
        'sanctionList': json['sanctionList'],
        'createdTime': (new Date(json['createdTime'])),
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'filters': ((json['filters'] as Array<any>).map(ApiSanctionFilterFromJSON)),
        'goodlistReference': json['goodlistReference'] == null ? undefined : ApiScreeningGoodlistReferenceFromJSON(json['goodlistReference']),
        'clearances': ((json['clearances'] as Array<any>).map(ApiScreeningHitClearanceStateFromJSON)),
        'screeningSubtype': json['screeningSubtype'] == null ? undefined : json['screeningSubtype'],
        'record': json['record'] == null ? undefined : ApiSanctionRecordFromJSON(json['record']),
        'matchProvider': json['matchProvider'] == null ? undefined : ApiScreeningMatchProviderFromJSON(json['matchProvider']),
        'screenablePath': json['screenablePath'] == null ? undefined : json['screenablePath'],
        'matchSourceId': json['matchSourceId'] == null ? undefined : json['matchSourceId'],
        'aiInsight': json['aiInsight'] == null ? undefined : ApiScreeningHitAiInsightFromJSON(json['aiInsight']),
    };
}

export function ApiSanctionHitToJSON(json: any): ApiSanctionHit {
    return ApiSanctionHitToJSONTyped(json, false);
}

export function ApiSanctionHitToJSONTyped(value?: ApiSanctionHit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sanctionAlertId': value['sanctionAlertId'],
        'score': value['score'],
        'inputData': value['inputData'],
        'matchData': value['matchData'],
        'sanctionList': value['sanctionList'],
        'createdTime': value['createdTime'].toISOString(),
        'highlight': value['highlight'],
        'filters': ((value['filters'] as Array<any>).map(ApiSanctionFilterToJSON)),
        'goodlistReference': ApiScreeningGoodlistReferenceToJSON(value['goodlistReference']),
        'clearances': ((value['clearances'] as Array<any>).map(ApiScreeningHitClearanceStateToJSON)),
        'screeningSubtype': value['screeningSubtype'],
        'record': ApiSanctionRecordToJSON(value['record']),
        'matchProvider': ApiScreeningMatchProviderToJSON(value['matchProvider']),
        'screenablePath': value['screenablePath'],
        'matchSourceId': value['matchSourceId'],
        'aiInsight': ApiScreeningHitAiInsightToJSON(value['aiInsight']),
    };
}

